import React from 'react'
import '../style/app.scss'
import SEO from '../components/seo'
import styled from 'styled-components'
import Jumbotron from '../components/Jumbotron';
import Bio from '../components/Bio';
import Achievements from '../components/Achievements'
import Featured from '../components/Featured'
import Works from '../components/Works'
import Contact from '../components/Contact'
import Videos from '../components/Videos'
import Testimonials from '../components/Testimonials'

const Container = styled.div`   
    margin: 0 auto;
    width: 100%;
`

const Content = styled.div`
	background-color: #fff;
	margin-top: 100vh;
`;

const IndexPage = () => (
    <>
        <SEO title="Emanuel Zevallos | Leading Emotion Code, Body Code Practitioner" />
        <Container>
            <Jumbotron />
            <Content>
                <Bio />
                <Achievements />
                <Featured />
                <Videos />
                <Works />
                <Testimonials/>
                <Contact />
            </Content>
        </Container>
    </>
)

export default IndexPage
